import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetProfileUserSummaryMutation = () => {
  const data = useMutation((userId) => {
    return axiosClient.post(`/User/GetProfileUserSummary?userId=${userId}`);
  });
  return  data;
};

export default useGetProfileUserSummaryMutation;
